import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleModalDiagramSoftDelete, diagramSoftDelete } from '../../../redux/main/main.actions';
import { selectIsModalDiagramSoftDeleteEnabled, selectModalDiagramSoftDeleteData } from '../../../redux/main/main.selectors';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalDiagramDeleteSoft.scss';

export const ModalDiagramDeleteSoft = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramSoftDeleteEnabled);
    const modalData = useSelector(selectModalDiagramSoftDeleteData);

    const [page, setPage] = useState('');

    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        setPage(modalData?.page);

        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }

        return () => { };
    }, [modalData]);

    const handleSave = () => {
        trackEvent('app_modal_diagram_delete_soft_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(diagramSoftDelete(modalData?.diagram?.id));
        dispatch(toggleModalDiagramSoftDelete(null));
        setTimeout(() => {
            setPage('');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramSoftDelete(null));
        setTimeout(() => {
            setPage('');
        }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-delete-soft ${page}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_diagram_archive.header')}</div>
            <div className="modal-content-body">
                <div className='description-text'>{t('m_diagram_archive.desc_prefix')}<span className='text-title-bold'>{value}</span>.</div>
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>{t('b.cancel')}</button>
                    <button onClick={() => handleSave()}>{t('b.archive')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramDeleteSoft;
